export default __webpack_public_path__ + "static/media/card.c77fe142.png";